import { ArrowRight } from "lucide-react";
import { ButtonLink } from "@/components/ButtonLink";
import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { progressionSteps, worldSystems } from "@/data/site";
import { useI18n } from "@/i18n/I18nProvider";

export function World() {
  const { t } = useI18n();

  return (
    <>
      <PageHero title={t("world.hero.title")} body={t("world.hero.body")} image="/concepts/aurel-world-map-concept.png" />

      <section className="content-band">
        <div className="section-inner split-layout">
          <img className="feature-image" src="/concepts/aurel-colony-concept.png" alt="" data-reveal />
          <div data-reveal>
            <p className="eyebrow">{t("brand.subtitle")}</p>
            <h2>{t("world.dual.title")}</h2>
            <p>{t("world.dual.body")}</p>
          </div>
        </div>
      </section>

      <section className="content-band parchment-band">
        <div className="section-inner">
          <SectionHeading title={t("world.systems.title")} />
          <div className="system-list">
            {worldSystems.map((system) => {
              const Icon = system.icon;
              return (
                <article className="system-row" key={system.key} data-reveal>
                  <Icon size={22} />
                  <p>{t(system.key)}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="image-band">
        <div className="section-inner split-layout reverse">
          <div className="progression-list" data-reveal>
            {progressionSteps.map((step, index) => (
              <div className="progression-step" key={step}>
                <span>{index + 1}</span>
                <p>{t(step)}</p>
              </div>
            ))}
          </div>
          <div data-reveal>
            <p className="eyebrow">{t("brand.subtitle")}</p>
            <h2>{t("world.progression.title")}</h2>
            <p>{t("media.verdancia.body")}</p>
          </div>
        </div>
      </section>

      <section className="content-band">
        <div className="section-inner split-layout">
          <div data-reveal>
            <h2>{t("world.map.title")}</h2>
            <p>{t("world.map.body")}</p>
            <div className="inline-actions">
              <ButtonLink href="/media" variant="secondary">
                {t("common.viewMedia")}
                <ArrowRight size={17} />
              </ButtonLink>
            </div>
          </div>
          <img className="feature-image" src="/concepts/aurel-world-map-concept.png" alt="" data-reveal />
        </div>
      </section>
    </>
  );
}
